module.exports = __webpack_public_path__ + "static/media/iconSondage.129b9fd9.svg";